import formatDate from "date-fns/format";
import React from "react";
import styled from "styled-components";

import { NodeEvent } from "../../generated/graphql";
import Text from "../shared/Text";

interface EventDateLocationProps {
  event: NodeEvent;
}

const EventDateLocation: React.FC<EventDateLocationProps> = props => {
  const { event } = props;
  return (
    <>
      <Location as="p">{event.fieldEventLocation}</Location>
      <EventDate as="p">
        {event.fieldStartDate?.value &&
          formatDate(
            new Date(event.fieldStartDate.value),
            "EEEE do MMMM yyyy -"
          )}
        {event.fieldEndDate?.value &&
          formatDate(new Date(event.fieldEndDate?.value), "EEEE do MMMM yyyy")}
      </EventDate>
    </>
  );
};

const Location = styled(Text)`
  padding-bottom: 0rem;
`;
const EventDate = styled(Text)``;

export default EventDateLocation;
